VP = window.VP || {};

(function( $ ) {
  VP.sitewideAlert = {
    swa:null,
    runcheck:true,
    enabled:false,
    title:"",
    ishome: $("body").hasClass("home"),

    init: function () {
      var _this = this;

      // Always show sitewide alert
      if (Cookies.get("swa") == "closed" && VP.helpers.getQParams("swa") != 1 && false) {
        // console.log("[sitewideAlert] cookie closed");
        _this.runcheck = false;
      }

      if (_this.runcheck) {
        // console.log("[sitewide alert] runcheck");

        VP.request.get(
          'sitewidealert',
        {
          rand: Math.round(Math.random() * 10000000),
          ishome: _this.ishome,
        },
          function ( response ) {

            if (response.indexOf("noalerts") > -1) {
              // console.log("[sitewideAlert] no active alerts");
              return;
            }
            else {
              // console.log("[sitewide alert] found");
              _this.enabled = true;

              $("body").append(response);

              _this.swa = $(".swa");


              if (_this.swa.length)  {
                if ( $(".swa__title").length ) {
                  _this.title = $(".swa__title").text();
                }
                VP.helpers.firecustomGTMEvent("sitewidealertViewed");

                $("body").addClass("swaenabled");
                _this.swa.fadeIn(500);

                $(".swa__close").on("click",function() {
                  if ( !$(this).data("clicked") ) {
                    VP.helpers.firecustomGTMEvent("sitewidealertClosed");
                    _this.swa.fadeOut(300);
                    Cookies.set("swa","closed");
                  }
                  $(this).data("clicked", true);
                  return false;
                });

                $(".swa__link").on("click",function() {
                  if ( !$(this).data("clicked") ) {
                    VP.helpers.firecustomGTMEvent("sitewidealertClicked");
                    Cookies.set("swa","closed");
                  }
                  $(this).data("clicked", true);
                });
              }
            }
          },
          function ( error, xhr ) {
            //console.error("Unable to get sitewidealert content.");
          }
        );

      }

    }
  };
})(jQuery);
